import { render, staticRenderFns } from "./CopyButton.vue?vue&type=template&id=84f16df8&scoped=true&"
import script from "./CopyButton.vue?vue&type=script&setup=true&lang=js&"
export * from "./CopyButton.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CopyButton.vue?vue&type=style&index=0&id=84f16df8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f16df8",
  null
  
)

export default component.exports